module.exports = __webpack_public_path__ + "f5180039853cc60345d5e0cde2042019.svg";